import { Directive, ElementRef, inject, OnDestroy, OnInit, output } from '@angular/core';

@Directive({
  selector: '[msEscClose]',
  standalone: true
})
export class EscCloseDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef<HTMLElement>);

  /** Emitted when Esc is pressed on the topmost shown modal. Parent should handle cancel/close logic. */
  public escPressed = output<void>();

  private handleKeydown = (event: KeyboardEvent): void => {
    if (event.key !== 'Escape') return;

    const modalEl = this.el.nativeElement;

    // Only act if this modal is currently shown
    if (!modalEl.classList.contains('show')) return;

    // Only act if this is the topmost shown modal
    const allShownModals = document.querySelectorAll('.modal.show');
    if (allShownModals.length === 0) return;
    if (allShownModals[allShownModals.length - 1] !== modalEl) return;

    event.preventDefault();
    event.stopPropagation();

    this.escPressed.emit();
  };

  ngOnInit(): void {
    document.addEventListener('keydown', this.handleKeydown);
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
